import {toast} from 'react-toastify'
import React, {Component} from 'react'
import Screen from './_Screen'
import Button from './Button'
import quickfield from './quickfield'
import extend from 'smart-extend'
import styled from 'styled-components'

class Step extends Screen
	render: (children, classes={})->
		<Screen {@props...}>
			<Heading>
				<Title>{@props.title}</Title>
				<Subtitle>{@props.subtitle}</Subtitle>
				<Divider />
			</Heading>
			
			<Fields className={classes.fields} ref={(@fieldsContainer)=>}>
				{children}
			</Fields>
			
			<Actions> 
				<Button label='Back' secondary action={@prev.bind(@)} />
				<Button label={@props.cta} action={@next.bind(@)} />
			</Actions>
		</Screen>

	setValues: (values)->
		values = extend.clone(@props.formState.values, values)
		@props.updateForm({values})

	collectValues: ()->
		return {}

	validate: ()->
		{valid:true}

	next: ()->
		{valid} = @validate()
		if valid
			super()
		else
			toast.error("You have forgotten to fill out some fields.")


Heading = styled.div"""
	text-align: center
"""

Title = styled.div"""
	font-size: 30px
	font-weight: 400
"""

Subtitle = styled.div"""
	max-width: 460px
	margin: 0 auto;
	margin-top: 8px
	font-size: 18px
	font-weight: 400
	line-height: 1.5
"""

Divider = styled.div"""
	background-color: #d9dde2
	height: 6px
	margin: 25px auto
	width: 80px
"""

Fields = styled.div"""
	display: flex
	flex-wrap: wrap
	justify-content: space-between
	width: 100%
	margin: 20px auto 0;
	text-align: left
"""

Actions = styled.div"""
	text-align: center
"""



export default Step